module.exports = __webpack_public_path__ + "img/roleManager.c1b39f48.svg";